
import ContainerFormComponent from "@/components/containers/ContainerForm.component.vue";
import ContainerListComponent from "@/components/containers/ContainerList.component.vue";
import SamplingPointMapComponent from "@/components/samplingPoints/SamplingPointMap.component.vue";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import securityService from "@/service/security.service";
import { Container } from "@/types";
import { AppType } from "@/types/app.type";
import { errorHandlerDefault } from "@/utils/handler.util";
import { ElMessage } from "element-plus";
import { defineComponent } from "vue";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: {
    ContainerListComponent,
    SamplingPointMapComponent,
    ContainerFormComponent,
    PageButtonsComponent,
  },
  setup() {
    const isAppAdmin = securityService.isApp(AppType.ADMIN);
    const isAppSupport = securityService.isApp(AppType.SUPPORT);
    const appIsAdminAndRoleIsAdmin = isAppAdmin && securityService.canAccessToApp(AppType.ADMIN);
    const listCanWrite = appIsAdminAndRoleIsAdmin;
    const canCreate = appIsAdminAndRoleIsAdmin;
    let detailRouterName;
    if (isAppAdmin) {
      detailRouterName = "adminContainerDetail";
    } else if (isAppSupport) {
      detailRouterName = "supportContainerDetail";
    }

    return {
      listCanWrite,
      canCreate,
      detailRouterName,
    };
  },
  data() {
    return {
      showMap: false,
      showContainerForm: false,
      containerForm: undefined as undefined | Container,
    };
  },
  async mounted() {
    const store = useStore<RootState>();
    const route = useRoute();
    const router = useRouter();

    if (store.state.auth.user?.id) {
      try {
        let userRoutes = await getAvailableRoutes(store.state.auth.user.id);
        if (userRoutes.length > 0 && !userRoutes.includes(route.path)) {
          router.go(-1);
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    }
  },
  methods: {
    changeView() {
      this.showMap = !this.showMap;
    },

    /**
     * open container formDialog
     * @param {Container|undefined=undefined} item
     */
    openContainerFormDialog(item: Container | undefined = undefined) {
      this.containerForm = item;
      this.showContainerForm = true;
    },

    /**
     * close container formDialog
     */
    closeContainerFormDialog() {
      this.showContainerForm = false;
      this.containerForm = undefined;
    },

    /**
     * save container
     */
    saveContainer() {
      // - call containerForm save method
      (this.$refs["containerForm"] as InstanceType<typeof ContainerFormComponent>)
        .doSave()
        ?.then(() => {
          // - close dialog and refresh
          this.closeContainerFormDialog();
          (
            this.$refs["containerList"] as InstanceType<typeof ContainerListComponent>
          ).refreshContainer();
          ElMessage.success(this.$t("success.action"));
        })
        .catch(errorHandlerDefault);
    },
  },
});
